import { STATUS_FIELD_NAME } from 'data/fields/hooks/account-fields';
import { byFieldName } from 'utils/by-field-name';

// TODO: Add proper types. I don't have much context here, I tried and there are different types I can see.
export const getTaskStatusField = (fields) => {
  const field = fields.find((f) => byFieldName(f, STATUS_FIELD_NAME));

  return field;
};
